import React, { useState } from 'react';
import * as Chance from 'chance';
import { useHistory } from "react-router-dom";
import '../styles/videochat.css';
import call from '../call.svg'


const chance = new Chance();

const VideoChat = ({ person }) => {
const [roomId, setRoomId] = useState('');
let history = useHistory();
return (
	<div id="videoChatLandingParent">
		<div className="videoChatLandingCol">
			<img src={call} alt="video call"/>
		</div>
		<div className="videoChatLandingCol">
			<div className="videoChatLandingText">
				<h1>Collaborate with tutors in real time.</h1>
				<p>
					We've integrated video chat into our core services in order to enable you to quickly connect with tutors across the globe.
				</p>
					<button
						type='button'
						onClick={() => {
						const id = chance.guid();
						history.push(`/room/${id}`);
						}}
						className="newMeetingBtn videoBtn videoBtnOutline"
					>
						Create Room
					</button>
					<input
						type='text'
						value={roomId}
						onChange={(e) => setRoomId(e.target.value)}
						placeholder="Enter Meeting Code Here"
					></input>
					<button
						type='button'
						onClick={() => {
						if (!roomId) {
							alert('RoomId is required');
							return;
						}
						history.push(`/room/${roomId}`);
						}}
						className="videoBtn"
					>
						Join Room
					</button>
			</div>
		</div>
	</div>
);
};

export default VideoChat